import { SvgProps } from "@/utils/types";

export const Blueberry = ({
  primaryColor = "#06B992",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_1007)">
        <path
          d="M15.35 28.74C22.7451 28.74 28.74 22.7451 28.74 15.35C28.74 7.9549 22.7451 1.95999 15.35 1.95999C7.95493 1.95999 1.96002 7.9549 1.96002 15.35C1.96002 22.7451 7.95493 28.74 15.35 28.74Z"
          fill={primaryColor}
        />
        <path
          d="M15.35 30.7C6.89 30.7 0 23.81 0 15.35C0 6.89 6.89 0 15.35 0C23.81 0 30.7 6.88 30.7 15.35C30.7 23.82 23.81 30.7 15.35 30.7ZM15.35 3.92C9.04 3.92 3.92 9.05 3.92 15.35C3.92 21.65 9.05 26.78 15.35 26.78C21.65 26.78 26.78 21.65 26.78 15.35C26.78 9.05 21.65 3.91 15.35 3.91V3.92Z"
          fill={outlineColor}
        />
        <path
          d="M17.64 15.4L18.2 14.71C18.51 14.33 19.02 14.19 19.47 14.37L20.3 14.69C21.32 15.08 22.24 13.94 21.64 13.03L21.15 12.28C20.89 11.87 20.91 11.34 21.22 10.96L21.78 10.27C22.46 9.42001 21.67 8.20001 20.62 8.48001L19.76 8.71001C19.29 8.84001 18.79 8.65001 18.53 8.24001L18.04 7.49001C17.45 6.58001 16.03 6.96001 15.98 8.04001L15.93 8.93001C15.9 9.42001 15.57 9.83001 15.1 9.96001L14.24 10.19C13.19 10.47 13.11 11.93 14.13 12.32L14.96 12.64C15.41 12.81 15.7 13.26 15.68 13.75L15.63 14.64C15.57 15.73 16.94 16.25 17.62 15.41L17.64 15.4Z"
          fill={outlineColor}
        />
        <path
          d="M16.33 23.22C15.26 23.22 12.24 22.97 9.77002 20.35C7.87002 18.33 7.44002 15.48 7.48002 13.71C7.45002 13.6 7.45002 13.47 7.48002 13.35C7.50002 13.26 7.51002 13.18 7.52002 13.11C7.57002 12.6 7.66002 12.25 7.74002 12.12L8.14002 11.54L8.79002 11.81C9.41002 12.07 9.38002 12.57 9.24002 13.39C9.18002 14.62 9.34002 17.35 11.04 19.15C13.41 21.67 16.44 21.48 16.57 21.47C17.05 21.44 17.47 21.8 17.5 22.27C17.53 22.75 17.18 23.17 16.7 23.2C16.64 23.2 16.52 23.21 16.34 23.21L16.33 23.22Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_1007">
          <rect width="30.7" height="30.7" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
